import { render } from "./Participant.vue?vue&type=template&id=d9d4d7ec&scoped=true"
import script from "./Participant.vue?vue&type=script&lang=js"
export * from "./Participant.vue?vue&type=script&lang=js"

import "./Participant.vue?vue&type=style&index=0&id=d9d4d7ec&lang=scss&scoped=true"

import exportComponent from "/Users/simongustafson/projekt/triathlon/triathlon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d4d7ec"]])

export default __exports__